import React, { useState, useMemo, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, List as ListComponent, useDrawer, Confirm, SplitButton } from 'src/mtska-frontend-app-component';
import { useGridApiRef } from '@mui/x-data-grid';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import TemporaryRemoval from "../externalbuttons/TemporaryRemoval";

import { AppContext, useSettingContextInComponent } from 'src/mtska-frontend-app-scaffolding';
import { useLoadAll } from 'src/mtska-frontend-data-provider/hooks/useLoadAll.hooks';
import JSONPretty from 'react-json-pretty'

const dataProviderName = 'audiences/audiencelead';
const dataImportProviderName = 'synchronizablelead/leadfile';
const drawerRouteBase = 'audiencelead';
const moduleName = "AudienceLeads";
const wizardAction = 'destroy';

const List = (params) => {
    const { t } = useTranslation();
    const { userCapabilities, appConfiguration } = useContext(AppContext);
    const { filterModel } = useSettingContextInComponent(dataProviderName);

    const { activate } = useDrawer();
    const [importerVersion, setImporterVersion] = useState(appConfiguration.importer.version ?? null);

    const apiRef = useGridApiRef();
    const getSelected = () => {
        return [...apiRef.current.getSelectedRows()].map(([name]) => name);
    };
    const [selected, setSelected] = useState([]);
    const handleRowSelection = (newSelection) => {
        setSelected(newSelection);
        params.rowSelectionExternalListener && params.rowSelectionExternalListener(newSelection);
    };

    const getFunctionalButtons = useMemo(() => {
        let rb = [];

        if (userCapabilities && userCapabilities[dataProviderName + '.delete'] && selected.length) {
            rb.push(
                <Button
                    disabled={userCapabilities && !userCapabilities[dataProviderName + '.delete']}
                    onClick={() => { handleDelete(); }}
                    label={t("Delete") + " (" + selected.length + ")"}
                    icon={"faTrash"}
                    variant="outlined"
                    size="small"
                    className="button-delete"
                />
            );
        }

        return rb;
    }, [selected, userCapabilities]);


    const [confirmDelete, setConfirmDelete] = useState();
    const handleDelete = () => {
        setConfirmDelete(
            <Confirm
                oklabel={t("Delete")}
                okcallable={async () => {
                    doAction && await doAction({ action: wizardAction, model: dataProviderName, data: getSelected() });
                    setConfirmDelete(null);
                    apiRef.current.setRowSelectionModel([]);
                    loadAll();
                }}
                kolabel={t("Cancel")}
                kocallable={() => { setConfirmDelete(null) }}
                title={t("Items elimination")}>
                {t("Are you sure to remove the selected elements?")}
            </Confirm>
        );
    }

    const { doAction, loadAll, items, total, loading, download, downloading, reloadCounter } = useDataProvider(dataProviderName);
    const [listFilterPageSort, setListFilterPageSort] = useState();
    const handleFilterPageSortChange = (model) => {
        setListFilterPageSort(model);
    }

    useLoadAll({ listFilterPageSort, loadAll, params, reloadCounter })

    const handleRowDoubleclick = (row) => {
        activate(drawerRouteBase + '/detail', { id: row.id });
    }

    const handleDownload = () => {
        download()
    }

    return (
        <>
            {/* <JSONPretty data={params} className='json-wrapper' />  */}
            {userCapabilities && userCapabilities[dataProviderName + '.list'] && (
                <ListComponent
                    {...params}
                    onRowDoubleClick={(userCapabilities && userCapabilities[dataProviderName + '.view']) ? handleRowDoubleclick : () => { }}
                    onFilterPageSortChange={handleFilterPageSortChange}
                    items={items}
                    total={total}
                    loading={loading}
                    apiRef={apiRef}
                    enableSelection
                    rightButtons={
                        //right buttons contiene gia i bottoni e fine. Deve funzionare sia per dove c'è rightbuttonns che no, mettendo i default
                        //devo solo passarmi bene i bottoni - tipo battezzare il bottone e chiamarlo dopo
                        params?.externalButtons?.includes('removalFromListButton')
                            ? [<TemporaryRemoval selectedElements={selected} />]
                            :
                                [
                                    ...getFunctionalButtons,
                                    <SplitButton
                                        className="gelsia-split-button"
                                        actions={[
                                            {
                                                disabled: userCapabilities && !userCapabilities[dataProviderName + '.create'],
                                                icon: "faAdd",
                                                label: t('New'),
                                                onClick: () => {
                                                    activate(drawerRouteBase + '/create', {
                                                        detailStack: params.detailStack ?? {},
                                                        relatedElements: params.relatedElements ?? {}
                                                    });
                                                }
                                            },
                                            {
                                                disabled: false,
                                                icon: "faCloudUpload",
                                                label: t('Importa da Margò'),
                                                onClick: () => {
                                                    activate(drawerRouteBase + '/importmargo', {});
                                                }
                                            },
                                            {
                                                disabled: false,
                                                icon: "faClipboardCheck",
                                                label: t('Pre verifica liste'),
                                                onClick: () => {
                                                    activate(drawerRouteBase + '/preverify', {
                                                        filters: { items: selected },
                                                        configDataProviderName: dataProviderName,
                                                        currentDataProviderName: importerVersion === "ImporterFileMappingConstants" ? dataImportProviderName : dataProviderName,
                                                        moduleName: moduleName,
                                                    });
                                                }
                                            },
                                            {
                                                disabled: selected.length === 0,
                                                icon: "faBan",
                                                label: t('Inserisci in blacklist'),
                                                onClick: () => {
                                                    activate(drawerRouteBase + '/blacklist', {
                                                        filters: { items: selected },
                                                    });
                                                }
                                            },
                                            {
                                                disabled: selected.length === 0,
                                                icon: "faTasks",
                                                label: t('Verifica RPO'),
                                                onClick: () => {
                                                    activate(drawerRouteBase + '/rpocheck', { selected });
                                                }
                                            },
                                            {
                                                disabled: filterModel?.items?.length === 0,
                                                icon: "faSave",
                                                label: t('Salva come segmento'),
                                                onClick: () => {
                                                    activate(drawerRouteBase + '/savesegment', { filterModel });
                                                }
                                            },
                                            {
                                                disabled: userCapabilities && !userCapabilities[dataProviderName + '.import'],
                                                icon: "faDownload",
                                                label: t('Import'),
                                                onClick: () => {
                                                    activate('imports/list', {
                                                        filters: { items: selected },
                                                        configDataProviderName: dataProviderName,
                                                        currentDataProviderName: importerVersion === "ImporterFileMappingConstants" ? dataImportProviderName : dataProviderName,
                                                        moduleName: moduleName,
                                                    });
                                                }
                                            },
                                            {
                                                disabled: userCapabilities && !userCapabilities[dataProviderName + '.export'],
                                                icon: "faUpload",
                                                label: t('Export'),
                                                onClick: () => {
                                                    activate('wizards/download', {
                                                        dataProviderName: dataProviderName,
                                                        recipe: 'recipes.audiences.global',
                                                        recipes: {
                                                            'wysiwyg': 'Your current view',
                                                            'recipes.audiences.global': 'Global view',
                                                            'recipes.audiences.anagrafical': 'Anagrafical view'
                                                        }
                                                    });
                                                }
                                            }
                                        ]}
                                    />

                                ]
                    }
                    dataProviderName={dataProviderName}
                    title={moduleName}
                    rowSelectionExternalListener={handleRowSelection}
                    doAction={doAction}
                />
            )}
            {confirmDelete}
        </>
    );
};

export default List;